import { useMemo } from "react";
import MassFlow from "../../components/massFlow";
import { MassFlowConfig } from "../../components/massFlow/types";
import { portMassColumns } from "../columns";
import { validatePort } from "../validation";
import { downloadCsvTemplate, portsFromCsv } from "./csv";
import { emptyPort, Port, PORT_FIELDS } from "../types";

export interface MassPortsProps {
  ports: Port[];
  search: string;
  onSearchChange: (value: string) => void;
  onBack: () => void;
  onSaved: () => Promise<void> | void;
}

export default function MassPorts(props: MassPortsProps) {
  const { ports, search, onSearchChange, onBack, onSaved } = props;

  const config = useMemo<MassFlowConfig>(
    () => ({
      tableId: "portsMassFlow",
      endpoint: "/easyFlow2.0/ports",
      entity: {
        singular: "porta",
        plural: "portas",
        gender: "f",
      },
      searchPlaceholder: "Pesquisar portas",
      fields: PORT_FIELDS,
      emptyValues: emptyPort,
      columns: portMassColumns,
      validate: validatePort,
      csv: {
        onDownloadTemplate: downloadCsvTemplate,
        parse: portsFromCsv,
      },
    }),
    [],
  );

  return (
    <MassFlow
      config={config}
      records={ports}
      search={search}
      onSearchChange={onSearchChange}
      onBack={onBack}
      onSaved={onSaved}
    />
  );
}
